import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";
import {mintEntityId} from "../utils/uid.utils";
import {ChangeLocalizationValuesCommand} from "./changeLocalizationValues.command";
import {AddImagePackCommand} from "./addImagePack.command";

export class AddTileCommand extends CommandBase {
    private name: string;
    // Id minted for the created tile; read after executeCommand to focus it.
    newId = '';
    constructor(name: string = 'New Tile') { super(); this.name = name; }
    execute(data: RemoteConstantsModel): boolean {
        data.tiles ??= [];
        const id = mintEntityId('tile', this.name, data.tiles.map(t => t.id));
        this.newId = id;
        data.tiles.push({
            id: id,
            active: true,
            rarity: 100,
            elevationNoise: {
                x: 0,
                y: 1
            },
            temperatureNoise: {
                x: 0,
                y: 1
            },
            additionalVisionRange: 0,
            movementPrice: 0,
            roadMovementPrice: 0.5,
            roadIsTrail: false,
            supportingTile: '',
            tileType: '',
            canMove: true,
            canSettle: false,
            canSail: false,
            canHide: false,
            canFortify: false,
            resources: [],
            buildings: []
        });

        new ChangeLocalizationValuesCommand(id, this.name).execute(data);
        new AddImagePackCommand(id).execute(data);
        return true;
    }
}